import React from 'react';
import DataGrid, {
  Column,
  Editing,
  Lookup,
  DataGridTypes,
} from 'devextreme-react/data-grid';
import useLookUpBase from '../../components/selectbox/LookupBase';
import { Capture } from './type';

interface ICapturesEmplacementsGrid {
  emplacements: Capture[];
  chasse: boolean;
  isModeModifier: boolean;
  selectedCaptureId?: string;
  onSelectionChanged: (idCapture: string | undefined) => void;
  onEmplacementUpdated: (emplacement: Capture) => void;
}

const CapturesEmplacementsGrid: React.FC<ICapturesEmplacementsGrid> = ({
  emplacements,
  chasse,
  isModeModifier,
  selectedCaptureId,
  onSelectionChanged,
  onEmplacementUpdated,
}) => {
  const { editorOptions: pointEauEditorOption } = useLookUpBase({
    isModeModifier,
    controllerName: 'pointeau',
    showClear: isModeModifier,
  });
  const { editorOptions: secteurEditorOption } = useLookUpBase({
    isModeModifier,
    controllerName: 'secteur',
    showClear: isModeModifier,
  });

  const handleFocusedRowChanged = (e: DataGridTypes.FocusedRowChangedEvent) => {
    onSelectionChanged(e.row?.data?.idCapture ? String(e.row.data.idCapture) : undefined);
  };

  const handleRowUpdated = (e: DataGridTypes.RowUpdatedEvent) => {
    onEmplacementUpdated(e.data as Capture);
  };

  return (
    <DataGrid
      dataSource={emplacements}
      keyExpr="idCapture"
      showBorders={true}
      allowColumnResizing={true}
      focusedRowEnabled={true}
      focusedRowKey={selectedCaptureId}
      onFocusedRowChanged={handleFocusedRowChanged}
      onRowUpdated={handleRowUpdated}
    >
      <Editing
        mode="cell"
        allowUpdating={isModeModifier}
        startEditAction="click"
      />
      <Column
        dataField={chasse ? 'idSecteur' : 'idPointEau'}
        caption={chasse ? 'Secteur' : "Point d'eau"}
      >
        {chasse
          ? <Lookup {...secteurEditorOption} />
          : <Lookup {...pointEauEditorOption} />}
      </Column>
      <Column dataField="nombrePersonne" caption="Nb. Pers." dataType="number" />
      <Column dataField="nombreJour" caption="Jours" dataType="number" />
      <Column dataField="prises" caption="Prises" dataType="number" allowEditing={false} />
    </DataGrid>
  );
};

export default CapturesEmplacementsGrid;
